import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { TabsUI } from "~/components/ui/TabsUI";
import type { ArticleListingStoryblok } from "~/generated/sb/blok-types";
import type { BlokData } from "~/srpc/routes/story.router";

export const ArticleListingBlok = ({
	blok,
	data,
	preview,
}: BlokProps<ArticleListingStoryblok, BlokData["articleListing"]>) => {
	return (
		<BlokWrap asChild editable={blok}>
			<TabsUI title={blok.title} tabsData={data} cardType="article" preview={preview} />
		</BlokWrap>
	);
};
